/**
 * Best-effort channel id from server payloads.
 * Supports `{ channel }`, `{ type }`, `{ topic }`.
 */
export function extractChannelId(parsed: unknown): string | undefined {
  if (!parsed || typeof parsed !== "object") {
    return undefined;
  }
  const o = parsed as Record<string, unknown>;
  if (typeof o.channel === "string") {
    return o.channel;
  }
  if (typeof o.type === "string") {
    return o.type;
  }
  if (typeof o.topic === "string") {
    return o.topic;
  }
  return undefined;
}
